import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError, map } from 'rxjs';
import { BackendResponse } from 'src/app/interfaces/response.interface';
import { handleError } from 'src/app/tools/tools';
import { environment } from 'src/environments/environment';

export interface AdjuntosI {
  id?: string;
  imagen?: string;
  description: string;
  active?: boolean;
}

export interface DataWells {
  mes: string;
  horas: number;
  km: number;
  datos: { lob: string; horas: number; km: number }[];
}

@Injectable({
  providedIn: 'root',
})
export class NovedadesService {
  constructor(private readonly http: HttpClient) {}

  private url = `${environment.url}adjuntos`;

  getImages() {
    return this.http.get<BackendResponse>(this.url).pipe(
      catchError((e) => handleError(e)),
      map((data) => data.result as AdjuntosI[])
    );
  }

  insertImage(form: FormData) {
    return this.http.post<BackendResponse>(this.url, form).pipe(
      catchError((e) => handleError(e)),
      map((data) => data.result as AdjuntosI)
    );
  }

  updateImage(id: string, form: FormData) {
    const direction = `${this.url}/${id}`;
    return this.http.put<BackendResponse>(direction, form).pipe(
      catchError((e) => handleError(e)),
      map((data) => data.result as AdjuntosI)
    );
  }

  getDashboardReport(params: HttpParams) {
    const direction = `${environment.url}spreadsheet-contractors/dashboard/reporte`;
    return this.http.get<BackendResponse>(direction, { params }).pipe(
      catchError((error) => handleError(error)),
      map(
        (data) =>
          data.result as {
            reportes: {
              [key: string]: {
                [key: string]: { km: number; horas: number };
              };
            };
            ultimosCargados: any;
          }
      )
    );
  }

  getDashboardReportWells(params: HttpParams) {
    const direction = `${environment.url}spreadsheet-contractors/dashboard/reporte/wells`;
    return this.http.get<BackendResponse>(direction, { params }).pipe(
      catchError((error) => handleError(error)),
      map((data) => data.result as DataWells[])
    );
  }

  getEmpresasFaltantes(params: HttpParams) {
    const direction = `${environment.url}lob/dashboard/periodos-faltantes`;
    return this.http.get<any>(direction, { params }).pipe(
      catchError((error) => handleError(error)),
      map((data) => data.result)
    );
  }
}
